export const HIDE_MODAL = 'hideModal'
export const MAKE_MODAL_VISIBLE = 'showModal'
export const SET_INVITE_STATS = 'setInviteStats'
export const MAKE_SLIDE_MENU_VISIBLE = 'showSlideMenuVisible'
export const SET_REVIEW_ANALYTICS_DATA = 'setReviewAnalyticsData'
export const SET_INDUSTRIES = 'setIndustries'
export const SET_GMB_DATA = 'setGmbData'



// WEBPACK FOOTER //
// ./src/store/mutation.types.js